import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { switchMap } from 'rxjs';
import { GoogleFontService } from '../../../services/google-font.service';
import { ButtonMenuItemComponent } from '../../../shared/components/button-menu-item/button-menu-item.component';
import { ContextMenuComponent } from '../../../shared/components/context-menu/context-menu.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { CapitalizePipe } from '../../../shared/pipes/capitalize.pipe';
import { AccessItemCtaComponent } from '../access-item-cta/access-item-cta.component';
import { AccessItemHeaderComponent } from '../access-item-header/access-item-header.component';
import { AccessItemComponent } from '../access-item/access-item.component';

@Component({
  selector: 'app-theme-font-style-item',
  imports: [
    AccessItemComponent,
    AccessItemHeaderComponent,
    AccessItemCtaComponent,
    ContextMenuComponent,
    ButtonDirective,
    SvgComponent,
    ButtonMenuItemComponent,
    CapitalizePipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './theme-font-style-item.component.html',
  styleUrl: './theme-font-style-item.component.scss',
})
export class ThemeFontStyleItemComponent {
  private googleFontService = inject(GoogleFontService);
  fontFamily = input.required<string>();
  fontStyle = input.required<string>();
  fontStyleChange = output<string>();
  italicAvailable = toSignal(
    toObservable(this.fontFamily).pipe(switchMap(fontFamily => this.googleFontService.hasItalic(fontFamily)))
  );

  styles = computed(() => {
    if (!this.italicAvailable()) return ['normal'];
    return ['normal', 'italic'];
  });
}
